import { Input } from '@builder.io/sdk';

import { moleculeHeadingFields } from 'molecules/Heading/config';
import sectionFields from 'molecules/Section/config';

import iconCardFields from 'organisms/Cards/IconCard/config';

const iconCardDeckFields = [
  ...moleculeHeadingFields,
  {
    name: 'cards',
    type: 'list',
    subFields: iconCardFields,
    helperText: 'Add up to 8 Icon Cards. Cards beyond the limit will be removed automatically.',
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onChange: (options: Map<string, any>) => {
      if (options.get('cards').length > 8) {
        options.set('cards', options.get('cards').slice(0, 8));
        alert('Maximum card count is 8. Removing excess cards.');
      }
    },
  },
  ...sectionFields,
] as const satisfies DeepReadonly<Input[]>;

const iconCardDeckConfig = {
  name: 'IconCardDeck',
  inputs: iconCardDeckFields,
};

export type IconCardDeckConfig = GenerateBuilder<typeof iconCardDeckFields>;

export default iconCardDeckConfig;
